(function($){

    var Buttons = {

        $items : null,

        init : function(){

            // $( 'body' ).on( 'click', 'button', function(){

            //     this.$ = this.$ || $( this );

            //     var active = this.$.hasClass( 'active' );
            //     if( active ){
            //         this.$.removeClass( 'active' );
            //         this.$.trigger( 'deactivate', this );
            //     }
            //     else {
            //         this.$.addClass( 'active' );
            //         this.$.trigger( 'activate', this );
            //     }

            // });

        }

    };

    $(function(){ 
        Buttons.init(); 
    });

})(jQuery);
